export default function calculateDataPercentage(dataArray = [], maxValue) {
  if (maxValue) {
    return dataArray.map(data => data / maxValue * 100)
  }

  const total = dataArray.reduce((data, nextData) => data + nextData, 0)

  return dataArray.map(data => data / total * 100)
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/calculateDataPercentage.js